import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type ErrorPageLayoutProps = {
  icon: React.ReactNode;
  color: 'error' | 'warning' | 'info';
  code: string;
  title: string;
  children: React.ReactNode;
};

const ErrorPageLayout: React.FC<ErrorPageLayoutProps> = ({
  icon,
  color,
  code,
  title,
  children,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 5,
          borderRadius: 3,
          border: 1,
          borderColor: 'divider',
          textAlign: 'center',
          maxWidth: 440,
          width: '100%',
          mx: 2,
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          {/* Icon with background circle */}
          <Box sx={{ position: 'relative', width: 88, height: 88 }}>
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                bgcolor: `${color}.main`,
                opacity: 0.1,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: `${color}.main`,
              }}
            >
              {icon}
            </Box>
          </Box>

          {/* Error code */}
          <Typography
            variant="h3"
            fontWeight={800}
            sx={{ color: `${color}.main`, letterSpacing: '-0.02em' }}
          >
            {code}
          </Typography>

          {/* Title */}
          <Typography variant="h6" fontWeight={700} color="text.primary">
            {title}
          </Typography>

          {/* Content (description + buttons) */}
          {children}
        </Stack>
      </Paper>
    </Box>
  );
};

export default ErrorPageLayout;
